export const calculateExpirationTime = (expiryTimeInMs) => {
  const expiryDate = new Date();
  try {
    expiryDate.setTime(expiryDate.getTime() + expiryTimeInMs);
    return parseInt(expiryDate.getTime() / 1000);
  } catch (e) {
    console.error("Error calculating expiry time " + e);
  }
};

export const isValidZipCode = (deliveryZipCode) => {
  if (deliveryZipCode) {
    return /^\d{5}$/.test(deliveryZipCode.toString().trim());
  }
  return false;
};

export const isAPOFPOZipCode = (zipCode) => {
  // Handle null, undefined, and empty string inputs explicitly
  if (zipCode === null || zipCode === undefined || zipCode === '') {
    return false;
  }
  
  const apoFpoRegex = /^(340|09(0|1|2|3|4|5|6|7|8)|96(2|3|4|5|6))\d{2}(?:-\d{4})?$/;
  
  const cleanedZipCode = String(zipCode).trim();

  return apoFpoRegex.test(cleanedZipCode);
};